// extracted by mini-css-extract-plugin
module.exports = {"header":"confirmModal_header__XhnTt","title":"confirmModal_title__2UESt","withdraw":"confirmModal_withdraw__2t5yu","proceed":"confirmModal_proceed__16Eu-"};